/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createIsInteger } from '../../factoriesAny.js';
export var isIntegerDependencies = {
  typedDependencies,
  createIsInteger
};